import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import WebShop from "./WebShop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Onboarding from "./components/Onboarding";
import Content from "./content/en";
//import "./HomePage.css";

export default function HomePage() {
  // Handle query string params here
  const searchParams = new URLSearchParams(window.location.search);
  const basketRefId = searchParams.get("basketRefId");
  const affilliateRef = searchParams.get("ref");
  const promoCode = searchParams.get("prm");
  const planSelected = searchParams.get("plan");

  return (
    <Router>
      <Header />
      <Routes>
        {/* <Route path="/" element={<Onboarding basketRefId={basketRefId} />} /> */}
        <Route path="*" element={
          <WebShop
            basketRefId={basketRefId}
            affilliateRef={affilliateRef}
            promoCode={promoCode}
            planSelected={planSelected}
          />}
        />
        {/* <Route path="/shop" element={<WebShop basketRefId={basketRefId} />} /> */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>
      <Footer />
    </Router>
  );
}
